import { atom } from 'jotai';

// 用户列表原子
export const currentEmpoyId = atom("");
// 用户总数原子

export const currentDateNew = atom([]);
